{
	"sent": {
		"title": "Conferência enviada",
		"tooltip": "Conferência de caixa enviada para o backoffice financeiro."
	},
	"pending": {
		"title": "Conferência pendente",
		"tooltip": "Conferência de caixa pendente para ser enviado para o backoffice financeiro."
	},
	"openPdv": "PDV's em aberto",
	"openTable": "Mesas em aberto"
}
